import { Link } from "react-router-dom";
import Banner from '../../assets/model_banner.png';

export const Hero = () => (
    <section className="relative overflow-hidden bg-navy-900 text-white">
        <div className="absolute inset-0">
            <img
                src={Banner}
                alt=""
                aria-hidden="true"
                className="w-full h-full object-cover opacity-30"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-navy-950 via-navy-900/85 to-navy-800/70" />
            <div className="absolute inset-0 bg-hero-radial" />
        </div>

        <div className="relative container-px mx-auto max-w-7xl pt-24 pb-28 md:pt-36 md:pb-40">
            <div className="max-w-3xl">
                <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-xs md:text-sm font-medium text-accent uppercase tracking-wider mb-6 animate-fade-in">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse" />
                    Structural Steel Detailing · Since 1993
                </span>

                <h1 className="text-display-xl font-display mb-6 animate-fade-up">
                    Shop drawings <span className="text-accent">you can build from.</span>
                </h1>

                <p className="text-lg md:text-xl text-steel-200 leading-relaxed mb-10 max-w-2xl animate-fade-up" style={{ animationDelay: '0.15s', animationFillMode: 'both' }}>
                    SDS2-certified 3D models and detailed drawings for structural and miscellaneous steel.
                    Trusted by fabricators across the western U.S. for over 30 years.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 animate-fade-up" style={{ animationDelay: '0.3s', animationFillMode: 'both' }}>
                    <Link
                        to="/contact-us"
                        className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-lg bg-signal text-signal-ink font-semibold text-base no-underline hover:bg-signal-hover transition-all duration-200 shadow-glow-accent hover:scale-[1.02]"
                    >
                        Request a Quote
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12" />
                            <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </Link>
                    <a
                        href="#projects"
                        className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-lg bg-white/5 border border-white/20 text-white font-semibold text-base no-underline hover:bg-white/10 transition-all duration-200"
                    >
                        See Our Work
                    </a>
                </div>

                <div className="mt-14 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-steel-300 animate-fade-in" style={{ animationDelay: '0.5s', animationFillMode: 'both' }}>
                    <span className="flex items-center gap-2">
                        <Check /> AISC Member
                    </span>
                    <span className="flex items-center gap-2">
                        <Check /> NISD Class I & II
                    </span>
                    <span className="flex items-center gap-2">
                        <Check /> SDS2 Certified
                    </span>
                    <span className="flex items-center gap-2">
                        <Check /> 500+ Projects Delivered
                    </span>
                </div>
            </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-white pointer-events-none" />
    </section>
);

const Check = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ADBF9" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);
